module.exports = __webpack_public_path__ + "media/control_acceso/layout_labeled-830763e1.png";